import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup, CustomInput,
    Label, Input, InputGroup, InputGroupAddon, Button
} from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import SelectCreate from "components/Varios/SelectCreate.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardOtrosProductos from "components/Varios/CardOtrosProductos.js";

import { authenticationService } from '../services/authentication.service';
import { mensajeCamposIncompletos } from './constants';

const id = 1043;
const API_URL = configData.SERVER_URL

export class OtrosProductosData {
    idthotrosproductos: number = 0;
    idpersona: number = 0;
    idcatalogo: number = 0;
    descripcion: string = "";
    fechaproducto: string = "";
    strtipoproducto?: string = "";
}

interface OtrosProductosDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: OtrosProductosData;
    OtrosProductosDataList: OtrosProductosData[];
    tipoOtrosProductosList: Array<any>;
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
}

export class OtrosProductos extends React.Component<RouteComponentProps<{}>, OtrosProductosDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new OtrosProductosData(),
            OtrosProductosDataList: [], tipoOtrosProductosList: [], error: null, tiposEvidencia: [], filesData: []
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarOtrosProductos = this.cargarOtrosProductos.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarOtrosProductos();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        fetch(API_URL + "DatosEscalafon/TipoOtrosProductos")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tipoOtrosProductosList: result.entTabla.map(d => ({
                                "value": d.idcatalogo,
                                "label": d.descripcion
                            })),
                        });
                    } else if (result.strEstado === "N") {
                        alertService.error("Ocurrió un error al obtener los tipos de institución.")
                    }
                    else {
                        alertService.error("Ocurrió un error al obtener los tipos de institución. " + result)
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        tipoOtrosProductosList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarOtrosProductos() {
        fetch(API_URL + "DatosEscalafon/OtrosProductosDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            OtrosProductosDataList: result.entTabla,
                            loading: false,
                            loadingList: false,
                        });
                    } else {
                        alertService.error("Ocurrió un error al obtener la información.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        OtrosProductosDataList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;

        this.setState({
            dtoData: dto,
        });
    }

    onClickLimpiar() {
        this.setState({ dtoData: new OtrosProductosData() });
    }

    onClickEdit(idotrosproductos) {
        this.setState({
            dtoData: new OtrosProductosData()
        });

        fetch(API_URL + "DatosEscalafon/OtrosProductosById/" + idotrosproductos)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            dtoData: result.entTabla[0],
                            loading: false
                        });

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);
                    } else {
                        alertService.error(result["strMensaje"])
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        dtoData: new OtrosProductosData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(idactividadacadservicio) {
        fetch(API_URL + "FormularioController/DeleteDatosOtrosProductos/" + idactividadacadservicio, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("La actividad académica se eliminó correctamente.")
                        this.cargarOtrosProductos();
                    }
                })
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        forma.forEach((value, clave) => {
            if (!value && clave !== "evidencias") {
                formIsValid = false;
                errors = "Por favor seleccione todos los campos. "
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;

            if (clave === 'fechaproducto') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                dto[clave] = date.toJSON();
            }
        });

        delete dto['strtipoproducto'];

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "entidad": dto,
        });

        if (formIsValid) {
            if (dto.idthotrosproductos === 0) {
                fetch(API_URL + "FormularioController/PostDatosOtrosProductos", {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,
                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(mensajeCamposIncompletos())
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("El producto se ha registrado correctamente.")

                                this.cargarOtrosProductos();
                                this.onClickLimpiar();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosOtrosProductos", {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,
                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])
                            }
                            else if (responseJson["strEstado"] === "S") {
                                alertService.success("El producto se ha actualizado correctamente.")

                                this.onClickLimpiar();
                                this.cargarOtrosProductos();
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        }
                        , (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        }
                    )
            }
        }
        else {
            alertService.error("Ocurrió un error: " + errors);
        }
    }

    public render() {
        let contents = this.state.loading || !this.state.currentUser.roles.includes("DOCENTEGRADO,")

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.OtrosProductosDataList, this.state.tipoOtrosProductosList, this.state.tiposEvidencia);
        return <div className="content">

            {contents}

        </div>;
    }

    // Returns the HTML Form to the render() method.

    private renderForm(OtrosProductosDataList: Array<any>, tipoOtrosProductosList: Array<any>, tiposEvidencia: Array<any>) {
        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">Otros Productos </h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <form onSubmit={this.handleSave}>
                                        <Row form>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="tipootrosproductos">Tipo de producto*</Label>
                                                    <SelectItem
                                                        options={tipoOtrosProductosList}
                                                        value={this.state.dtoData.idcatalogo}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="idcatalogo"
                                                        id="tipootrosproductos"
                                                        icon="fa-caret-right"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={5}>
                                                <FormGroup>
                                                    <Label for="descripcion">Descripción*</Label>
                                                    <Input maxLength="500" name="descripcion" id="descripcion" value={this.state.dtoData.descripcion} onChange={this.handleChange} required />
                                                </FormGroup>
                                            </Col>
                                            <Col md={2}>
                                                <Label for="fechaproducto">Año Producto*</Label>
                                                <Datepicker
                                                    value={this.state.dtoData.fechaproducto}
                                                    name="fechaproducto"
                                                    id="fechaproducto"
                                                    dateFormat="yyyy"
                                                    onChange={this.handleSelectChange}
                                                />
                                            </Col>
                                        </Row>

                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                    <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                    </form >
                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {OtrosProductosDataList.map((dto, index) =>
                                                <CardOtrosProductos
                                                    key={dto.idthotrosproductos}
                                                    objeto={dto}
                                                    number={(index + 1) + " / " + OtrosProductosDataList.length}
                                                    eventEdit={() => this.onClickEdit(dto.idthotrosproductos)}
                                                    eventDelete={() => this.onClickDelete(dto.idthotrosproductos)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default OtrosProductos;